import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AccessStore } from '../stores/access.store';
import { isFeatureEnabled, FEATURE_FLAGS } from '../shared/utils/feature-flags';
import { PERMISSION } from 'utils/permissions/permission-catalog';

/**
 * Gate for every route under /ai. Two conditions, both required:
 *  - the `ai_module_enabled` feature flag is on — the environment kill switch;
 *  - the caller holds the `ai.access` entitlement in the active org (§9.2),
 *    granted through a role or per member from the Access panel; ubers pass
 *    through can() as everywhere else.
 *
 * The sidenav's AI group and the floating launcher use the same gate, so a
 * hidden menu is always a blocked route and vice versa.
 *
 * The access profile loads asynchronously (see AppComponent), so on a cold
 * navigation straight to a guarded URL it may not be present yet — ensure it
 * first, then evaluate; ensureLoaded fails closed on error.
 */
export const aiModuleGuard: CanActivateFn = () => {
  const accessStore = inject(AccessStore);
  const router = inject(Router);

  if (!isFeatureEnabled(FEATURE_FLAGS.AI_MODULE_ENABLED)) {
    return router.createUrlTree(['/home']);
  }

  return accessStore
    .ensureLoaded()
    .pipe(
      map((profile) =>
        profile !== null && accessStore.can(PERMISSION.ai.access)
          ? true
          : router.createUrlTree(['/home'])
      )
    );
};
